import { buildQuery, requestJson } from "./apiClient";

export async function fetchPrivacyDashboard() {
  return requestJson("/api/admin/privacy/dashboard");
}

export async function listPrivacyRequests(params = {}) {
  return requestJson(`/api/admin/privacy/requests${buildQuery(params)}`);
}

export async function getPrivacyRequest(requestId) {
  return requestJson(`/api/admin/privacy/requests/${encodeURIComponent(requestId)}`);
}

export async function assignPrivacyRequest(requestId, body = {}) {
  return requestJson(`/api/admin/privacy/requests/${encodeURIComponent(requestId)}/assign`, {
    method: "POST",
    body,
  });
}

export async function approvePrivacyRequest(requestId, body = {}) {
  return requestJson(`/api/admin/privacy/requests/${encodeURIComponent(requestId)}/approve`, {
    method: "POST",
    body,
  });
}

export async function rejectPrivacyRequest(requestId, body = {}) {
  return requestJson(`/api/admin/privacy/requests/${encodeURIComponent(requestId)}/reject`, {
    method: "POST",
    body,
  });
}

export async function listPrivacyVendors() {
  return requestJson("/api/admin/privacy/vendors");
}

export async function listRetentionRules() {
  return requestJson("/api/admin/privacy/retention-rules");
}

export async function listPrivacyIncidents(params = {}) {
  return requestJson(`/api/admin/privacy/incidents${buildQuery(params)}`);
}

export async function createPrivacyIncident(body) {
  return requestJson("/api/admin/privacy/incidents", { method: "POST", body });
}

export async function createLegalHold(body) {
  return requestJson("/api/admin/privacy/legal-holds", { method: "POST", body });
}
